import { jsx as a } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import m from "@mui/material/Skeleton";
import i from "styled-components";
const k = {
  root: "skeletonRoot",
  component: "skeletonComponent",
  disabled: "skeletonDisabled",
  label: "skeletonLabel"
}, p = i(m).withConfig({
  displayName: "StyledSkeleton"
})([
  "&.skeletonRoot{background-color:",
  ";box-shadow:none;}"
], ({ theme: e }) => e.primaryBorder), f = /* @__PURE__ */ d(({ classes: e, animation: o = "pulse", variant: t = "rectangular", height: l = 10, width: n = 150, ...s }, r) => /* @__PURE__ */ a(p, {
  ref: r,
  animation: o,
  variant: t,
  height: l,
  width: n,
  classes: {
    ...k,
    ...e
  },
  ...s
}));
f.displayName = "Skeleton";
export {
  f as default
};
